// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IPaymentDetailsResponseDto,
} from '../models/index';
import {
    IPaymentDetailsResponseDtoFromJSON,
    IPaymentDetailsResponseDtoToJSON,
} from '../models/index';

export interface GetPaymentDetailsRequest {
    postingId: number;
    employeeId?: number;
}

/**
 * PaymentDetailsControllerApi - interface
 * 
 * @export
 * @interface PaymentDetailsControllerApiInterface
 */
export interface PaymentDetailsControllerApiInterface {
    /**
     * Retrieves check payment details associated with a posting
     * @summary Get payment details for a posting
     * @param {number} postingId 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsControllerApiInterface
     */
    getPaymentDetailsRaw(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentDetailsResponseDto>>;

    /**
     * Retrieves check payment details associated with a posting
     * Get payment details for a posting
     */
    getPaymentDetails(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentDetailsResponseDto>;

}

/**
 * 
 */
export class PaymentDetailsControllerApi extends runtime.BaseAPI implements PaymentDetailsControllerApiInterface {

    /**
     * Retrieves check payment details associated with a posting
     * Get payment details for a posting
     */
    async getPaymentDetailsRaw(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPaymentDetailsResponseDto>> {
        if (requestParameters['postingId'] == null) {
            throw new runtime.RequiredError(
                'postingId',
                'Required parameter "postingId" was null or undefined when calling getPaymentDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/postings/{postingId}/payment-details`;
        urlPath = urlPath.replace(`{${"postingId"}}`, encodeURIComponent(String(requestParameters['postingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPaymentDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves check payment details associated with a posting
     * Get payment details for a posting
     */
    async getPaymentDetails(requestParameters: GetPaymentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPaymentDetailsResponseDto> {
        const response = await this.getPaymentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
